import { ViewModel, View } from "binder"
import { StopReasonEditorView } from "./stopReasonEditor-view"
import { IStopReason } from "../IStopReason";
import { IPopup } from "src/common/userMainWindow/windowContainer/IPopup";
import { ServerConnection } from "src/server/serverConnection";
import { stringIsNullOrEmpty } from "src/common/utilities";
import { StopGroupSelectorViewModel } from "../stopGroupSelector-viewModel";

export class StopReasonEditorViewModel extends ViewModel implements IStopReason, IPopup {
    constructor(parentViewModel: ViewModel, updater: IServerUpdater) {
        super(parentViewModel);
        this._serverUpdater = updater;
        this.stopGroupSelector = new StopGroupSelectorViewModel(this);
    }
    GetDefaultView(): View<ViewModel> {
        return new StopReasonEditorView();
    }
    public getTypeId(): string {
        return "VM-D7010643-6137-4AA0-BF7C-0186C3DBCF4F"
    }

    private _serverUpdater: IServerUpdater;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;
    public set id(v: string) { this._id = v; } public get id(): string { return this._id; } private _id: string;
    public set name(v: string) { this._name = v; } public get name(): string { return this._name; } private _name: string;
    public set stopGroupId(v: string) { this._stopGroupId = v; } public get stopGroupId(): string { return this._stopGroupId; } private _stopGroupId: string;
    public set stopGroupSelector(v: StopGroupSelectorViewModel) { this._stopGroupSelector = v; } public get stopGroupSelector(): StopGroupSelectorViewModel { return this._stopGroupSelector; } private _stopGroupSelector: StopGroupSelectorViewModel;
    public set isDisable(v: boolean) { this._isDisable = v; } public get isDisable(): boolean { return this._isDisable; } private _isDisable: boolean;

    setStopGroupId(id: string) {
        this.stopGroupSelector.selectById(id);
    }
    getStopGroupId(): string {
        return this.stopGroupSelector.selectedItem?.id;
    }

    closePopup(result?: any) {

    }

    async cloneTo(stopReason: IStopReason) {
        stopReason.id = this.id;
        stopReason.name = this.name;
        stopReason.setStopGroupId(this.getStopGroupId());
    }

    back() {
        this.closePopup(null);
    }

    async save() {
        let verificationResult = this.verify();
        if (verificationResult.length > 0) {
            this.messageBoxConfirmWarning(verificationResult.join('\n'), 'خطا در ثبت علت توقف');
            return;
        } else {
            try {
                this.isLoading = true;
                let result = await this._serverUpdater.execute(this);
                if (result.IsSuccessful == false) {
                    if (result.Faults[0].Parameters.FaultId == '0444EA07-B96F-44B0-9432-47851CEB6078') {
                        await this.messageBoxConfirmWarning('اطلاعات به اشتباه وارد شده است.', 'خطا در عملیات');
                    }
                    else if (result.Faults[0].Parameters.FaultId == '096473E7-67AE-4206-9B61-79B70943684A') {
                        await this.messageBoxConfirmWarning('امکان ثبت علت توقف تکراری وجود ندارد.', 'خطا در عملیات');
                    }
                }
                else {
                    await this.messageBoxConfirmSuccess('علت توقف با موفقیت ثبت شد.', 'ثبت موفق');
                    this.closePopup('done');
                }
            }
            catch (ex) {
                await this.messageBoxConfirmWarning('خطا در ثبت علت توقف', 'خطا در عملیات');
                console.log(ex);
            } finally {
                this.isLoading = false;
            }
        }
    }

    verify(): string[] {
        let result: string[] = [];
        if (stringIsNullOrEmpty(this.getStopGroupId())) {
            result.push('گروه توقف مشخص نشده است.');
        }
        if (stringIsNullOrEmpty(this.name)) {
            result.push('علت توقف مشخص نشده است.');
        }
        return result;
    }
}

export interface IServerUpdater {
    execute(stopReason: IStopReason): Promise<any>;
}

export class StopReasonInserter implements IServerUpdater {
    async execute(stopReason: IStopReason): Promise<any> {
        try {
            let result = await ServerConnection.callServer('/Complex/StopReasonServices/CreateStopReason', {
                Name: stopReason.name,
                StopGroupId: stopReason.getStopGroupId()
            });
            return result;
        } catch (ex) {
            throw ex;
        }
    }
}

export class StopReasonUpdater implements IServerUpdater {
    async execute(stopReason: IStopReason): Promise<any> {
        try {
            let result = await ServerConnection.callServer('/Complex/StopReasonServices/UpdateStopReason', {
                StopReasonId: stopReason.id,
                Name: stopReason.name,
                StopGroupId: stopReason.getStopGroupId()
            });
            return result;
        } catch (ex) {
            throw ex;
        }
    }
}

